module.exports = __webpack_public_path__ + "static/frontierbanner-d8ad633b0af5f4999640101c27f2693b.jpg";